import { BcStateForm } from '@bayclubs/state';

export const COURT_EVENT_MODALS_FEATURE_KEY = 'cbCourtEventModals';

export interface CourtEventModalsStateModel {
    cancelReasonForm: BcStateForm<CancelCourtBookingForm>;
    cancelBlockedSlotForm: BcStateForm<CancelBlockedSlotForm>;
}

export interface CancelCourtBookingForm {
    reason: string;
}

export interface CancelBlockedSlotForm {
    reason: string;
    cancelMode: CancelBlockedSlotMode;
}

export enum CancelBlockedSlotMode {
  thisEvent = 'this-event',
  thisAndFollowing = 'this-and-following'
}
